// Request-type sets shared by InspectraNetworkView and its tests. Lives outside the
// component so a test can import it without mounting the Requests view (which pulls
// in react-router). Keep activeview_measurement in both: /pcs/activeview left
// google_impression in viewability WP1 and is a beacon, not an impression.

export const PAGE_INHERIT_TYPES = new Set([
  'prebid', 'amazon', 'amazon_video',
  'google_impression', 'google_click', 'activeview_measurement',
  'omid_impression', 'omid_measurement', 'omid_session', 'omid_video', 'omid_test_beacon',
  'amazon_impression', 'prebid_win', 'bidder_impression',
  'impression', 'click', 'measurement', 'analytics', 'ima', 'video_content',
  'vast_tracking', 'vast_error', 'sdk_bidding',
  // Non-content infrastructure: consent, config, telemetry, and anything the
  // classifier couldn't label. These fire inside a page load but never ARE a
  // page, so they inherit the surrounding content page instead of spawning a
  // bogus top-level group (e.g. privacy.foxnews.com, logx.optimizely.com).
  'unclassified', 'other', 'configuration', 'context', 'privacy',
]);

// Beacon request types - viewability pings, impression pixels, click redirects. One set feeds both
// the Hide-Trackers filter and the per-visit hidden-beacon count. `activeview_measurement` is here
// because /pcs/activeview left google_impression (viewability WP1).
export const BEACON_TYPES_SET = new Set([
  'omid_measurement', 'omid_impression', 'omid_session', 'omid_video', 'omid_test_beacon',
  'impression', 'click', 'google_impression', 'google_click', 'activeview_measurement',
  'measurement', 'analytics',
]);
